module.exports = __webpack_public_path__ + "img/icon2.5c7f30ca.png";